import { sendWebsocketMessage } from '../../../../../App';
/**
 * The idea is that this is supposed to end up being like an "inbox" for users,
 *  or a way we can send out like an alert to them. it needs a lot of work on B.E and F.E though
 * @param {String} key of message
 */
export function sendHasSeenMessage(key){
    const msg = {
        key: key,
        messageType: "markMessageSeenInMessageCenter",
    };
    sendWebsocketMessage(msg);
}